/* Dermatinta v3 (16-oct, pedido de Santiago): oferta 1-2-3 y suscripción, la pregunta «¿cómo está tu tatuaje?» en ventana,
   la rama en zigzag que rodea la página con brillos y el comparador ilustrado. Sin dependencias; todo es mejora progresiva:
   sin este archivo la página funciona igual (1 unidad, compra única, sin ventana ni rama). */
(function () {
  'use strict';
  var raiz = document.documentElement;
  function quieto() { return !!(window.DTMotion && window.DTMotion.quiet && window.DTMotion.quiet()); }
  function guardar(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* modo privado: no pasa nada */ } }
  function leer(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }

  /* ---------- 1 · Una sola autoridad para cantidad, total y payload ---------- */
  // dermatinta.js monta/desmonta el formulario y aplica compra única sin descuentos no verificados.
  window.DTOferta = { pintar: function () { if (window.DTCompra) window.DTCompra.pintar(); } };

  /* ---------- 2 · Perfil único para teclado, ratón, popup y restauración ---------- */
  (function pregunta() {
    var temporizador = 0, abierta = false;
    function seccion() { return document.querySelector('[data-momento]'); }
    function aplicar(radio, mover) {
      var sec = seccion();
      if (!sec || !radio) return;
      radio.checked = true;
      var perfil = radio.getAttribute('data-perfil') || radio.value;
      raiz.setAttribute('data-perfil', perfil);
      Array.prototype.forEach.call(sec.querySelectorAll('[data-panel]'), function (p) { p.hidden = p.getAttribute('data-panel') !== radio.value; });
      // Reciente no es una pauta clínica: mostramos espuma con aviso, nunca crema/kit.
      var elegir = perfil === 'reciente' ? 'espuma' : radio.getAttribute('data-elegir');
      if (window.DTCompra && elegir) window.DTCompra.elegir(elegir, false);
      var aviso = sec.querySelector('[data-perfil-aviso]');
      if (aviso) {
        aviso.hidden = perfil !== 'reciente';
        aviso.textContent = perfil === 'reciente' ? 'Sigue primero las indicaciones de tu tatuador. Mostrar la espuma no indica que debas usarla desde el primer día. La crema y el kit son para piel ya cerrada, sin costras ni heridas abiertas.' : '';
      }
      guardar('dt-perfil', perfil);
      if (mover) sec.scrollIntoView({ behavior: quieto() ? 'auto' : 'smooth', block: 'start' });
    }
    function buscar(id) {
      var sec = seccion();
      return sec && Array.prototype.find.call(sec.querySelectorAll('input[data-perfil]'), function (r) { return r.value === id || r.getAttribute('data-perfil') === id; });
    }
    function abrir() {
      var dlg = document.querySelector('[data-quiz]');
      if (!dlg || typeof dlg.showModal !== 'function' || abierta || leer('dt-perfil') || leer('dt-quiz-visto') || document.querySelector('dialog[open]') || raiz.classList.contains('carrito-abierto')) return;
      try { dlg.showModal(); abierta = true; guardar('dt-quiz-visto', '1'); clearTimeout(temporizador); } catch (e) { /* dialog desconectado */ }
    }
    function montar() {
      clearTimeout(temporizador);
      var r = buscar(leer('dt-perfil'));
      if (r) aplicar(r, false);
      if (seccion() && !r && !leer('dt-quiz-visto')) temporizador = setTimeout(abrir, 9000);
    }
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-momento] input[data-perfil]') && e.target.checked) aplicar(e.target, false);
    });
    document.addEventListener('click', function (e) {
      var op = e.target.closest && e.target.closest('[data-quiz-op]');
      var dlg = e.target.closest && e.target.closest('[data-quiz]');
      if (op && dlg) { dlg.close(); aplicar(buscar(op.getAttribute('data-quiz-op')), true); }
      else if (dlg && (e.target === dlg || e.target.closest('[data-quiz-cerrar]'))) dlg.close();
    });
    window.addEventListener('scroll', function () {
      var hero = document.getElementById('inicio');
      if (window.scrollY > (hero ? hero.offsetTop + hero.offsetHeight * 0.6 : 400)) abrir();
    }, { passive: true });
    document.addEventListener('shopify:section:load', montar);
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target.querySelector('[data-momento]')) { clearTimeout(temporizador); var dlg = e.target.querySelector('[data-quiz]'); if (dlg && dlg.open) dlg.close(); abierta = false; }
    });
    montar();
  })();

  /* ---------- 3 · Rama en zigzag que rodea la página, con brillos ---------- */
  (function rama() {
    var capa = document.querySelector('[data-rama-fondo]');
    var main = document.getElementById('contenido');
    if (!capa || !main || !window.requestAnimationFrame) return;
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'rama-fondo__svg'); svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    capa.appendChild(svg);
    var tallo = null, largo = 0, raf = 0;
    function hoja(x, y, ang, tam, i) {
      var p = document.createElementNS(NS, 'path');
      var a = tam, b = tam * 0.42;
      p.setAttribute('d', 'M0,0 C' + (a * .3) + ',' + (-b) + ' ' + (a * .72) + ',' + (-b) + ' ' + a + ',0 C' + (a * .72) + ',' + b + ' ' + (a * .3) + ',' + b + ' 0,0 Z');
      p.setAttribute('class', 'rama-fondo__hoja'); p.setAttribute('transform', 'translate(' + x.toFixed(1) + ',' + y.toFixed(1) + ') rotate(' + ang.toFixed(1) + ')');
      p.style.setProperty('--i', i);
      return p;
    }
    function brillo(x, y, i) {
      var g = document.createElementNS(NS, 'path');
      var r = 7 + (i % 3) * 2;
      g.setAttribute('d', 'M0,' + (-r) + ' Q1.2,-1.2 ' + r + ',0 Q1.2,1.2 0,' + r + ' Q-1.2,1.2 ' + (-r) + ',0 Q-1.2,-1.2 0,' + (-r) + ' Z');
      g.setAttribute('class', 'rama-fondo__brillo'); g.setAttribute('transform', 'translate(' + x.toFixed(1) + ',' + y.toFixed(1) + ')');
      g.style.setProperty('--d', ((i * 0.83) % 4.2).toFixed(2) + 's');
      return g;
    }
    function construir() {
      var ancho = document.documentElement.clientWidth;
      var alto = main.offsetHeight;
      var top0 = main.offsetTop;
      capa.style.top = top0 + 'px'; capa.style.height = alto + 'px';
      svg.setAttribute('viewBox', '0 0 ' + ancho + ' ' + alto); svg.setAttribute('width', ancho); svg.setAttribute('height', alto);
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      var margen = ancho < 750 ? 7 : Math.max(16, (ancho - 1180) / 2 - 18);
      var izq = margen, der = ancho - margen;
      var secciones = Array.prototype.filter.call(main.children, function (el) { return el.offsetHeight > 120; });
      if (!secciones.length) return;
      var d = '', lado = 0, y0 = 30;
      d = 'M' + izq + ',' + y0;
      secciones.forEach(function (s, i) {
        var y1 = s.offsetTop - top0 + s.offsetHeight;        // borde de abajo de la sección
        var x = lado === 0 ? izq : der;
        var bajo = Math.max(y0 + 40, y1 - 70);
        d += ' L' + x + ',' + bajo;                            // baja pegada al borde
        if (i < secciones.length - 1) {
          var otro = lado === 0 ? der : izq;
          var y2 = y1 + 70;
          d += ' C' + x + ',' + (bajo + 60) + ' ' + otro + ',' + (y2 - 60) + ' ' + otro + ',' + y2;   // cruza en la juntura
          y0 = y2; lado = 1 - lado;
        }
      });
      tallo = document.createElementNS(NS, 'path');
      tallo.setAttribute('d', d); tallo.setAttribute('class', 'rama-fondo__tallo');
      svg.appendChild(tallo);
      largo = tallo.getTotalLength();
      tallo.style.strokeDasharray = largo; tallo.style.strokeDashoffset = quieto() ? 0 : largo;
      var paso = ancho < 750 ? 120 : 150, i = 0;
      for (var l = 60; l < largo - 20; l += paso, i++) {
        var p = tallo.getPointAtLength(l), q = tallo.getPointAtLength(Math.min(largo, l + 2));
        var ang = Math.atan2(q.y - p.y, q.x - p.x) * 180 / Math.PI + (i % 2 ? 50 : -50);
        var h = hoja(p.x, p.y, ang, ancho < 750 ? 14 : 20, i);
        h.setAttribute('data-l', l);
        svg.appendChild(h);
        if (i % 2 === 0) {
          var b = brillo(p.x + (i % 4 ? 10 : -10), p.y - 12, i);
          b.setAttribute('data-l', l);
          svg.appendChild(b);
        }
      }
      dibujar();
    }
    function dibujar() {
      raf = 0;
      if (!tallo) return;
      var vista = window.scrollY + window.innerHeight * 0.85 - main.offsetTop;
      var frac = quieto() ? 1 : Math.max(0, Math.min(1, vista / main.offsetHeight));
      // el largo dibujado sigue al scroll; las hojas y brillos aparecen cuando el tallo llega a ellos
      var hecho = largo * Math.min(1, frac * 1.04);
      tallo.style.strokeDashoffset = (largo - hecho).toFixed(1);
      Array.prototype.forEach.call(svg.querySelectorAll('[data-l]'), function (el) {
        el.classList.toggle('is-in', +el.getAttribute('data-l') <= hecho);
      });
    }
    function pedir() { if (!raf) raf = requestAnimationFrame(dibujar); }
    var esperar = 0;
    function rehacer() { clearTimeout(esperar); esperar = setTimeout(construir, 180); }
    window.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', rehacer);
    window.addEventListener('load', rehacer);
    if (window.ResizeObserver) new ResizeObserver(rehacer).observe(main);
    if (window.DTMotion && window.DTMotion.subscribe) window.DTMotion.subscribe(pedir);
    construir();
  })();

  /* ---------- 4 · Comparador ilustrado, también tras carga del editor ---------- */
  function comparar(rango) {
    var c = rango && rango.closest('[data-comparador]');
    if (c) c.style.setProperty('--corte', rango.value + '%');
  }
  function montarComparadores(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-comparador] input[type="range"]'), comparar);
  }
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-comparador] input[type="range"]')) comparar(e.target);
  });
  document.addEventListener('shopify:section:load', function (e) { montarComparadores(e.target); });
  montarComparadores(document);
}());
